module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.0a69c7fa.jpg";